import * as React from 'react';

import { ApplicationState } from 'clients/app/src/rootReducer';
import { useSelector } from 'react-redux';

interface Props {
  answerIds: (string | number)[];
}

const QuestionShortAnswerDisplay: React.FunctionComponent<Props> = ({
  answerIds,
}: React.PropsWithChildren<Props>) => {
  const answers = useSelector((state: ApplicationState) =>
    answerIds.map((a) => state.teachers.quizData.answers[a])
  );

  return (
    <div className="flex flex-wrap max-w-5xl sm:pr-12 p-0 -mt-4">
      {answers.map((answer) => (
        <span
          key={answer.id}
          className="px-4 py-3 mr-4 mt-4 rounded-1 text-display inline-block text-green-600 bg-green-50"
        >
          {answer.text}
        </span>
      ))}
    </div>
  );
};

export default QuestionShortAnswerDisplay;
